import { ILinkWidgetGeneratorType } from "./../../../shared/interfaces/ILinkWidgetGeneratorType";
import { DashboardQuickLinkModel } from "../../../shared/models/DashboardQuickLinkModel";
import { Pages } from "@constants/pages/Pages";
import { ApplicationPermissionsModel } from "@models/permissions/ApplicationPermissionsModel";

export class AdminLinkGenerator implements ILinkWidgetGeneratorType {
    getTypes(permissions: ApplicationPermissionsModel, pages: Pages): DashboardQuickLinkModel[] {
        const quickLinks = [];
        if (permissions.Documents.Admin) {
            quickLinks.push({
                title: "linkWidget.adminDocumentsTitle",
                icon: "fad fa-folder",
                page: pages.AdminDocuments,

                description: "linkWidget.adminDocumentsDescription",
            });
        }

        if (permissions.DocumentTemplates.HasAccess) {
            quickLinks.push({
                title: "linkWidget.documentTemplatesTitle",
                icon: "fad fa-folder",
                page: pages.DocumentTemplates,

                description: "linkWidget.documentTemplatesDescription",
            });
        }

        if (permissions.Documents.Admin) {
            quickLinks.push({
                title: "linkWidget.bulkDeletedDocumentsTitle",
                icon: "fad fa-trash",
                page: pages.BulkDeletedDocuments,

                description: "linkWidget.bulkDeletedDocumentsDescription",
            });
        }

        if (permissions.HasDeletedItemsAccess) {
            quickLinks.push({
                title: "linkWidget.deletedItemsTitle",
                icon: "fad fa-trash",
                page: pages.DeletedItems,

                description: "linkWidget.deletedItemsDescription",
            });
        }

        if (permissions.MailMessages.HasMailAccess) {
            quickLinks.push({
                title: "linkWidget.mailMessagesTitle",
                icon: "fad fa-envelope",
                page: pages.MailMessages,

                description: "linkWidget.mailMessagesDescription",
            });
        }

        if (permissions.HasInviteAccess) {
            quickLinks.push({
                title: "linkWidget.inviteTitle",
                icon: "fad fa-paper-plane",
                page: pages.Invite,

                description: "linkWidget.inviteDescription",
            });
        }

        if (permissions.HasPeriodAccess) {
            quickLinks.push({
                title: "linkWidget.periodsTitle",
                icon: "fad fa-business-time",
                page: pages.Periods,

                description: "linkWidget.periodsDescription",
            });
        }

        if (permissions.HasStandingDataAccess) {
            quickLinks.push({
                title: "linkWidget.standingDataTitle",
                icon: "fad fa-edit",
                page: pages.StandingDataOverview,

                description: "linkWidget.standingDataDescription",
            });
        }

        if (permissions.UserMaintenance.hasAccess) {
            quickLinks.push({
                title: "linkWidget.userManagementTitle",
                icon: "fad fa-users-cog",
                page: pages.UserManagement,

                description: "linkWidget.userManagementDescription",
            });
        }

        if (permissions.IsApplicationAdmin) {
            quickLinks.push({
                title: "linkWidget.externalConnectionsTitle",
                icon: "fad fa-exchange-alt",
                page: pages.ExternalConnections,
            });
        }

        if (permissions.IsApplicationAdmin) {
            quickLinks.push({
                title: "linkWidget.environmentSettingsTitle",
                icon: "fad fa-cogs",
                page: pages.Settings,

                description: "linkWidget.environmentSettingsDescription",
            });
        }

        if (permissions.HasAiSettingsAccess) {
            quickLinks.push({
                title: "linkWidget.aiSettingsTitle",
                icon: "fa-duotone fa-solid fa-sparkles",
                page: pages.AiSettings,

                description: "linkWidget.aiSettingsDescription",
            });
        }

        quickLinks.push({
            title: "linkWidget.schedulerStatusTitle",
            icon: "fad fa-clock",
            page: pages.SchedulerStatus,
            description: "linkWidget.schedulerStatusDescription",
        });

        if (permissions.IsApplicationAdmin) {
            quickLinks.push({
                title: "linkWidget.workdayOrganizerTitle",
                icon: "fad fa-calendar-check",
                page: pages.WorkdayOrganizer,
                description: "linkWidget.workdayOrganizerDescription",
            });
        }

        if (permissions.HasOrganizationBudgetAccess) {
            quickLinks.push({
                title: "linkWidget.organizationalBudgetTitle",
                icon: "fad fa-piggy-bank",
                page: pages.OrganizationBudgets,

                description: "linkWidget.organizationalBudgetDescription",
            });
        }

        return quickLinks;
    }
}
